import React from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import { Icon } from '../Icon';

export type DialogProps = {
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  maxWidth?: number | string;
  hideClose?: boolean;
};

export const Dialog: React.FC<DialogProps> = ({
  open,
  defaultOpen,
  onOpenChange,
  trigger,
  title,
  description,
  children,
  footer,
  maxWidth = 480,
  hideClose,
}) => (
  <RadixDialog.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
    {trigger && <RadixDialog.Trigger asChild>{trigger}</RadixDialog.Trigger>}
    <RadixDialog.Portal>
      <RadixDialog.Overlay
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(13, 16, 39, 0.5)',
          zIndex: 100,
        }}
      />
      <RadixDialog.Content
        className="card"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90vw',
          maxWidth,
          maxHeight: '85vh',
          overflow: 'auto',
          padding: 24,
          zIndex: 101,
          boxShadow: 'var(--shd-3)',
        }}
      >
        {(title || !hideClose) && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: title ? 8 : 0,
            }}
          >
            {title && (
              <RadixDialog.Title style={{ fontSize: 18, fontWeight: 600, color: 'var(--ink)' }}>
                {title}
              </RadixDialog.Title>
            )}
            {!hideClose && (
              <RadixDialog.Close asChild>
                <button type="button" className="btn btn-ghost btn-icon" aria-label="Close">
                  <Icon name="x" size={16} />
                </button>
              </RadixDialog.Close>
            )}
          </div>
        )}
        {description && (
          <RadixDialog.Description className="muted" style={{ marginBottom: 12, fontSize: 13 }}>
            {description}
          </RadixDialog.Description>
        )}
        {children}
        {footer && <div style={{ marginTop: 16 }}>{footer}</div>}
      </RadixDialog.Content>
    </RadixDialog.Portal>
  </RadixDialog.Root>
);

export const DialogClose = RadixDialog.Close;
